import { render, staticRenderFns } from "./TheSnapshotTablePreview.vue?vue&type=template&id=7f4ffd7e&"
import script from "./TheSnapshotTablePreview.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotTablePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports